export default "__VITE_PUBLIC_ASSET__5cb7d662__"